import { getElementsInProposal } from '@shared/helpers/proposal.helpers';
import { getElementCategoryId } from '../../../helpers/element-category.helpers';
import { getElementPropertyResolvedCountByNameOrId } from '../../../helpers/element-property.helpers';
import { getElementQuantityResolvedCountByName } from '../../../helpers/element-quantity.helpers';
import { sum } from '../../../helpers/math.helpers';
import { ElementCategoryID } from '../../../models/element-categories.model';
import { Baseline, OneOfElements } from '../../../models/project.model';
import {
  WindowsDoorsCategory,
  WindowsDoorsPropertyName,
} from './windows-doors.model';

/**
 * Check if an element is a window element
 * @param element
 * @returns
 */
export const isWindowElement = (element: OneOfElements): boolean => {
  if (getElementCategoryId(element) === ElementCategoryID.WindowsDoors) {
    const type = getElementPropertyResolvedCountByNameOrId(
      element,
      WindowsDoorsPropertyName.WindowsDoorsCategory,
    );
    return type === WindowsDoorsCategory.Window;
  }
  return false;
};

/**
 * Get the total area of all window elements in a building version.
 * Note that this only include windows and not doors
 * @param version
 * @returns
 */
export const getWindowArea = (version: Baseline | undefined): number => {
  if (!version) {
    return 0;
  }
  const windows = getElementsInProposal(version).filter(isWindowElement);
  return sum(
    windows.map((w) => getElementQuantityResolvedCountByName(w, 'area_side')),
  );
};
